import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { ClientCornerHomePageColleague } from '../helper/client-corner-home-page-colleague';
import { Observable } from 'rxjs';
import { _get } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ClientCornerHomePageColleagueListControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) =>
    res as ClientCornerHomePageColleague[];

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };

    this.get = _get('/clientHomePage/colleagues', requestServices);
  }

  public colleagues(
    companyId: number
  ): Promise<ClientCornerHomePageColleague[]> {
    return this.get(`/${companyId}`, this.deserialize).toPromise();
  }
}
